import Quill from 'quill';
import 'quill-paste-smart';
import { Mention, MentionBlot } from 'quill-mention';

import 'quill/dist/quill.snow.css';
import 'quill-mention/dist/quill.mention.css';

Quill.register({
  'blots/mention': MentionBlot,
  'modules/mention': Mention,
});

// Whitelisting the 'storage' toolbar item so we can register a click handler
const Parchment = Quill.import('parchment');
const StorageClass = new Parchment.ClassAttributor('storage', 'ql-storage', {
  scope: Parchment.Scope.INLINE
});
Quill.register(StorageClass, true);

// Setting custom quill icons
const icons = Quill.import('ui/icons');
icons.storage = '<i class="bb-icon small icon-storage-filled" aria-hidden="true"></i>';
